var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.664 5.684l-0.544-0.544c0.078-0.179 0.127-0.368 0.139-0.562 0.026-0.435-0.121-0.835-0.416-1.13l-1.745-1.745c-0.206-0.206-0.437-0.31-0.687-0.31-0.449 0-0.769 0.323-1.108 0.666l-9.036 9.036-0.335 2.955 0.105 0.104-0.972 0.972 1.193 0.222 0.487-0.486 0.104 0.104 2.954-0.333 8.697-8.698 0.456 0.456c0.072 0.072 0.094 0.144 0.076 0.245-0.026 0.141-0.129 0.31-0.283 0.464l-3.016 3.017 0.707 0.707 3.016-3.017c0.303-0.302 0.497-0.645 0.56-0.99 0.078-0.426-0.047-0.829-0.352-1.133zM5.343 13.677l-2.128 0.241-0.235-0.235 0.242-2.126 5.622-5.622 2.121 2.121-5.622 5.621zM11.672 7.349l-2.121-2.121 2.464-2.464c0.136-0.139 0.342-0.347 0.376-0.354l1.745 1.745c0.12 0.12 0.129 0.278 0.125 0.361-0.010 0.168-0.088 0.331-0.218 0.462l-2.371 2.371z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerAlt);
export default __webpack_public_path__ + "static/media/marker-alt.f2c9d713.svg";
export { ForwardRef as ReactComponent };